import React, { useRef } from 'react';
import Slider from "react-slick";
import ReadFeaturedCard from "../ReadFeaturedCard";
import stripHtml from "../../../Components/StripHTML";
import {v4 as uuidv4} from "uuid";

const FeaturedSlider = ({ featuredReads, settings, slider }) => {


    return (
        <Slider ref={slider} {...settings}>
            {featuredReads &&
                featuredReads.map((featuredRead) => {
                    const { title, content, authorAvatar, featured, date } = featuredRead;

                    return (
                        <ReadFeaturedCard
                            imgSrc={featuredRead?._embedded?.["wp:featuredmedia"]?.[0]?.source_url ?? null}
                            favourite={false}
                            title={stripHtml(title?.rendered ?? "")}
                            text={content?.rendered ?? ""}
                            authorName={featuredRead?._embedded?.author?.[0]?.name ?? ""}
                            authorAvatar={authorAvatar ?? null}
                            featured={featured ?? null}
                            key={uuidv4()}
                            mediaType={featuredRead?.type ?? null}
                            mediaId={featuredRead?.id ?? null}
                            date={date ?? null}
                        />
                    );
                })}
        </Slider>
    );
};

export default FeaturedSlider;